const input = "_35si1pmgiw2";
const facit = "_35sf6qyql3";

export { facit, input };
import "./input.content.style.linaria.module.css";
//# sourceMappingURL=input.content.style.js.map
